import styled from 'styled-components';
import { FullHeightColumn } from '../../../layout/Column';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LeftColumn = styled(FullHeightColumn as any)`
  min-height: 100%;
  padding: 10px;
  @media (max-width: 990px) {
    padding-top: 20px;
    flex: 0;
  }
`;
